import Link from 'atomic/link';
import React from 'react';
import Container from 'atomic/container';
import WidgetSectionProps from './widget-section.props';
import Icon from 'atomic/icon';
import classNames from 'classnames';
import WidgetDSA from 'modules/shared/widgets/components/widget-dsa';
import { showDSA } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';

import './widget-section.scss';

const WidgetSection: React.FC<WidgetSectionProps> = (
    {
        className,
        title,
        link,
        badge,
        styles,
        children,
        id,
        anchor,
        dataSection
    }
) => {
    const isShowBadge = badge?.text?.trim() || badge?.dsa?.advertiserName?.trim() || badge?.dsa?.advertiserId?.trim();

    return (
        <div
            id={id}
            data-section={dataSection}
            className={classNames({
                'widget-section': true,
                'widget-section--none-bg': !styles?.background?.url,
                [String(className)]: Boolean(className)
            })}
            style={{
                backgroundColor: styles?.background?.color ?? void 0,
                backgroundImage: styles?.background?.url ? `url(${styles?.background?.url})` : void 0,
                backgroundPosition: styles?.background?.position || 'center'
            }}
        >
            {anchor && <span id={anchor} className="widget-section__anchor" aria-hidden="true" />}
            <Container>
                {(title?.text?.trim() || isShowBadge) && (
                    <div className="widget-section__header">
                        {React.createElement(isShowBadge ? 'div' : 'h2', {
                            style: { color: title?.styles?.color },
                            className: classNames({
                                'widget-section__header__title': true,
                                'widget-section__header__title--badge-text': isShowBadge && title?.text?.trim(),
                                'widget-section__header__title--pt-0': !styles?.background?.url && !isShowBadge
                            })
                        }, (
                            <>
                                {title?.text?.trim()}
                                {isShowBadge && (
                                    <span
                                        className="widget-section__header__title__badge"
                                        style={{
                                            color: badge?.styles?.color || '#fff',
                                            backgroundColor: badge?.styles?.background || '#0f5faf'
                                        }}
                                    >
                                        {badge?.text}
                                        {badge?.dsa && showDSA(badge.dsa) && (
                                            <WidgetDSA
                                                className="widget-section__header__title__dsa"
                                                dsa={badge.dsa}
                                                size={12}
                                            />
                                        )}
                                    </span>
                                )}
                            </>
                        ))}
                        {link?.url && (
                            <Link
                                color={link?.styles?.color ?? 'secondary'}
                                href={link.url}
                                className="widget-section__header__link"
                            >
                                {link?.text || ' Sprawdź pozostałe'}
                                <Icon name="arrow-right" color="primary" size={20} />
                            </Link>
                        )}
                    </div>
                )}
                {children}
            </Container>
        </div>
    );
};

export default WidgetSection;
